class CombinedSearchService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    /***
     * Gets clients, campuses, and facilities that start with the provided search_id.
     *
     * @param search_id     the id of the client, campus/location, or facility
     *
     * @returns {Promise}
     */
    searchById(search_id) {
        const config = {
            params: {
                search_id: search_id,
            }
        };
        return this.$http.get(`${this.appConfig.apiUrl}/clients/search`, config);
    }

}

export default CombinedSearchService;


// WEBPACK FOOTER //
// ./app/components/client-admin/combined-search/combined-service.js